import { CheckoutOrderFragment, FlightSegment, OrderStatus } from '@websky/graphql';
import OrderDataLayer from './OrderDataLayer';
import { DataLayerAnalytics } from '../DataLayerAnalytics';
import { OrderStep } from '../types';
import { OrderType } from './types';

class CheckoutDataLayer extends OrderDataLayer<CheckoutOrderFragment> {
	public constructor(instance: DataLayerAnalytics) {
		super(instance);
	}

	public getOrderType(): OrderType {
		return OrderType.Checkout;
	}

	public getFlightSegments(): FlightSegment[] {
		return this.getOrder().flight.segments.map(segment => segment.segment) as FlightSegment[];
	}

	public getOrderStatus(): OrderStep {
		return this.getOrder().status === OrderStatus.New
			? OrderStep.Booking
			: this.getOrder().status === OrderStatus.Confirmed
			? OrderStep.Paid
			: OrderStep.Checkout;
	}
}

export default CheckoutDataLayer;
